import styled from "@emotion/styled";
import { Button, Modal, theme } from "@xometry/xometry_loft";

export const StyledHoopsModal = styled(Modal)`
  box-sizing: border-box;
  margin: 0;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  overflow: hidden;
  transform: translateZ(1px);

  ${theme.mediaQueries.small} {
    max-width: 100%;
  }
`;

export const HoopsCloseButton = styled(Button)`
  z-index: 9;
  position: absolute;
  right: 40px;
`;
